// ** Third Party Components
import styled from "styled-components";

// ** Custom Components
import { Icon } from "components/icons";

// #####################################################

export const StyledIcon = styled((props) => (
	<Icon name="angle-right" variant="light" {...props} />
))`
	font-size: 0.9rem;
	line-height: 1.2rem;
	margin: 0 0.25rem;
	display: inline-block;
	text-align: center;
	position: relative;
	top: 0.1rem;
`;

// #####################################################
